(function() {
  var Router, Storage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  Storage = App.loadClass('core::Storage');

  exports.PlantingRxRouter = (function(superClass) {
    extend(PlantingRxRouter, superClass);

    function PlantingRxRouter() {
      return PlantingRxRouter.__super__.constructor.apply(this, arguments);
    }

    PlantingRxRouter.prototype.prefix = 'PlantingRx';

    PlantingRxRouter.prototype.module_name = 'PlantingRxRouter';

    PlantingRxRouter.prototype.register = function() {
      var dir;
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      dir = App.load('grower::Angular/Data/PlantingRx/Directives/rxPlantingRow');
      dir.register(this.module);
      this.service('grower::Angular/Data/PlantingRx/Services/SeedCompaniesService', ['$http', '$rootScope']);
      this.service('grower::Angular/Data/PlantingRx/Services/ProductsService', ['$http', '$rootScope']);
      this.service('grower::Angular/Data/PlantingRx/Services/MachineryService', ['$http', '$rootScope']);
      this.service('grower::Angular/Data/PlantingRx/Services/PlantingRxService', ['$http', '$rootScope']);
      this.service('grower::Angular/Data/PlantingRx/Services/VisualLayersService', ['$http', '$rootScope', '$q']);
      this.service('grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']);
      this.controller('grower::Angular/Data/PlantingRx/SidebarController', ['$scope', '$transitions', '$state', 'PlantingRx.Services.MachineryService', 'RxOptions', 'PlantingRx.Services.PlantingRxService', 'Core.Services.Map', 'Core.Services.MapLayers.Manager', 'Grower.Services.TruthStripToolbar', 'Core.Services.Loading']);
      this.controller('grower::Angular/Data/PlantingRx/ProductPlanterController', ['$scope', '$transitions', 'PlantingRx.Services.PlantingRxService', '$q', 'PlantingRx.Services.SeedCompaniesService', 'PlantingRx.Services.ProductsService']);
      this.controller('grower::Angular/Data/PlantingRx/LayersController', ['$scope', '$transitions', 'Core.Services.Map', 'PlantingRx.Services.VisualLayersService', 'Core.Services.MapLayers.Manager', 'Core.Services.Loading']);
      this.controller('grower::Angular/Data/PlantingRx/TruthStripsController', ['$scope', '$transitions', 'Core.Services.Map', 'PlantingRx.Services.VisualLayersService', 'Core.Services.MapLayers.Manager', 'Grower.Services.TruthStripToolbar', 'Core.Services.Loading']);
      this.controller('grower::Angular/Data/PlantingRx/PrescriptionController', ['$scope', '$transitions', 'Core.Services.Map', '$state', 'PlantingRx.Services.PlantingRxService', 'PlantingRx.Services.VisualLayersService', 'Core.Services.MapLayers.Manager', 'Core.Services.Loading', 'PlantingRx.Services.LegendService']);
      return this.controller('grower::Angular/Data/PlantingRx/TableViewController', ['$scope', '$transitions', 'PlantingRx.Services.PlantingRxService']);
    };

    PlantingRxRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('grower.planting-rx', {
        url: '/planting-rx/{id}',
        templateUrl: 'backend/grower/layers/planting-rx/ng-sidebar',
        resolve: {
          RxOptions: function() {
            var store;
            if (window.RxStorage != null) {
              store = window.RxStorage;
              window.RxStorage = null;
            } else {
              store = new Storage();
            }
            return store;
          }
        },
        controller: 'PlantingRx.Controllers.SidebarController'
      }).state('grower.planting-rx.products', {
        url: '',
        views: {
          'fullpage': {
            templateUrl: 'backend/grower/layers/planting-rx/ng-product-planter',
            controller: 'PlantingRx.Controllers.ProductPlanterController'
          }
        }
      }).state('grower.planting-rx.layers', {
        url: '',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/layers/planting-rx/ng-layers',
            controller: 'PlantingRx.Controllers.LayersController'
          }
        }
      }).state('grower.planting-rx.truth-strips', {
        url: '',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/layers/planting-rx/ng-truthstrips',
            controller: 'PlantingRx.Controllers.TruthStripsController'
          }
        }
      }).state('grower.planting-rx.prescription', {
        url: '',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/layers/planting-rx/ng-prescription',
            controller: 'PlantingRx.Controllers.PrescriptionController'
          }
        }
      }).state('grower.planting-rx.prescription.table', {
        url: '',
        views: {
          'fullpage@grower.planting-rx': {
            templateUrl: 'backend/grower/layers/planting-rx/ng-table',
            controller: 'PlantingRx.Controllers.TableViewController'
          }
        }
      });
    };

    return PlantingRxRouter;

  })(Router);

}).call(this);
